import { Suspense, useContext, useEffect, useState, useRef } from "react";
import { fetchData } from "./data";
import { Button, IconBut } from "../ui/buttons";
import { Host, Loading } from "../App";
import { once, transitionEnd } from "../ui/helpers";
import { ToggleOverlay } from "./contexts";
import { SearchBar } from "./library";



export function Decks({ name, active }) {
    const mainRef = useRef(null);

    useEffect(() => {
        active === name && mainRef.current.scrollIntoView({
            behaviour: "smooth",
            inline: "start"
        })
    }, [name, active])


    return (
        <div className="max" ref={mainRef} style={{ backgroundColor: "red" }}>
            <div className="max pad" style={{ overflow: "hidden auto" }}>
                <div className="abs-mid">
                    <Suspense fallback={<Loading />}>
                        <DecksList />
                    </Suspense>
                </div>
            </div>
        </div>
    )
}



function DecksList() {
    const [filter, setFilter] = useState('');

    const list = fetchData(`${Host}/flashquiz/decks`, devData);


    return (
        <>
            <SearchBar value={filter} changeSearch={setFilter} />
            {
                list.length ?
                    <div className="flex f-list">
                        {
                            list.map(item =>
                                <FlashSet key={item.id} data={item} filter={filter} />
                            )
                        }
                    </div>
                    :
                    <div className="abs-mid">
                        {/* image */}
                        <p>
                            Group study texts and materials to keep <br />
                            things organized and share with squad members
                        </p>
                        <div className="margin">
                            <Button> Create FlashSet </Button>
                        </div>
                    </div>
            }
        </>
    )
}


function FlashSet({ data, filter }) {
    const { title, descr } = data;
    const openOverlay = useContext(ToggleOverlay).open

    return (
        filter && !(title.includes(filter) || descr.includes(filter)) ?
            <></>
            :
            <div className="f-item br-1" style={{ margin: "10px" }} onClick={handleClick}>
                <div className="flex">
                    {/* folder image */}
                    <div className="flex-col" style={{ padding: "5px" }}>
                        <span style={{ fontWeight: "500" }}> {title} </span>
                        <small> {descr} </small>
                    </div>
                </div>
            </div>

    )

    function handleClick() {
        openOverlay("deck-details", data.id);
    }
}



// deck-details
export function DeckDetails({ show, id }) {
    const parentRef = useRef(null);

    const details = fetchData(Host + "/flashquiz/decks/" + id)


    const tgOverlay = useContext(ToggleOverlay), closeOverlay = tgOverlay.close, openOverlay = tgOverlay.open;

    useEffect(() => {
        let t_id = show && parentRef.current.classList.remove("close");

        return () => {
            clearTimeout(t_id);
        }
    }, [show])


    return (
        show &&
        <div className='interface close' ref={parentRef}>
            <div className="content max" style={{ overflow: "hidden auto" }}>
                <div className="max flex-col">
                    <div className='heading fw pad' style={{ position: "sticky" }}>
                        <div className='flex fw mid-align' style={{ justifyContent: "space-between" }}>
                            <IconBut className="fa-solid fa-angle-left" onClick={close}>
                                <span className='sr-only'>Back</span>
                            </IconBut>

                            <div className="flex mid-align" style={{ gap: "10px" }}>
                                <IconBut className="fa-solid fa-share" onClick={shareDeck}>
                                    <span className='sr-only'>Share</span>
                                </IconBut>
                                <IconBut className="fa-solid v-ellipsis" onClick={toggleDrop}>
                                    <span className='sr-only'>More details</span>
                                </IconBut>
                            </div>

                        </div>
                    </div>
                    <div className="pad grow">
                        <Button onClick={loadDeck}>
                            Practice
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )

    function shareDeck() {

    }

    function toggleDrop() {

    }

    function loadDeck() {
        openOverlay('flashdeck', id);
        close();
    }

    function close() {
        once(transitionEnd, () => {
            // setDisplay(false);
            closeOverlay("deck-details");
        });

        parentRef.current.classList.add("close");
    }
}


const devData = [
    { title: "CHE 102", descr: "Folder containing CHE 102 materials" },
    { title: "GNS 102", descr: "Folder containing GNS 102 materials" },
    { title: "PHY 102", descr: "Folder containing PHY 102 materials" },
    { title: "MTS 102", descr: "Folder containing MTS 102 materials" },
    { title: "GNS 106", descr: "Folder containing GNS 106 materials" },
    { title: "CSC 102", descr: "Folder containing CSC 102 materials" },
]